export function ellipsisize(text: string, maxLength = 20, ellipsis = '...'): string {
    if (text.length <= maxLength) {
        return text
    }
    return text.slice(0, maxLength) + ellipsis
}
